
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DefaultBackdrop from './default-backdrop';
import DefaultDialog from './default-dialog';
import { useEffect, useMemo } from 'react';
import DefaultMessage from './default-message';
import ApplicationAppService from '../application/platform/application-app-service';
import { BaseLayoutProvider } from './context/base-layout-context';
import { useBaseLayoutController } from './context/base-layout-controller';
import { createAppTheme } from '../theme/theme';

function SandboxBanner() {
    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: (t) => t.zIndex.tooltip + 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                py: 0.75,
                px: 2,
                bgcolor: 'warning.main',
                color: 'warning.contrastText',
                boxShadow: '0 -2px 8px rgba(0,0,0,0.15)',
            }}
        >
            <WarningAmberIcon fontSize="small" />
            <Typography sx={{ fontSize: '0.8125rem', fontWeight: 600, letterSpacing: 0.3 }}>
                Ambiente de Homologação — os dados aqui não são de produção
            </Typography>
        </Box>
    );
}

function BaseLayoutContent({ children }: { children: React.ReactNode }) {
    const applicationData = ApplicationAppService.getApplicationData();
    const { dialogProps, messageProps, loadingProps, showMessage, showLoading } = useBaseLayoutController();
    const theme = useMemo(() => createAppTheme(applicationData.moduleId), [applicationData.moduleId]);

    useEffect(() => {
        document.title = applicationData.moduleName;
    }, [applicationData.moduleName]);

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <DefaultBackdrop {...loadingProps}></DefaultBackdrop>
                <DefaultMessage {...messageProps}></DefaultMessage>
                <DefaultDialog {...dialogProps}></DefaultDialog>
                {children}
                {applicationData.isSandbox && <SandboxBanner />}
            </Box>
        </ThemeProvider>
    );
}

export default function BaseLayout({ children }: { children: React.ReactNode }) {
    return (
        <BaseLayoutProvider>
            <BaseLayoutContent>
                {children}
            </BaseLayoutContent>
        </BaseLayoutProvider>
    );
}